<div class="footer">
  <div class="float-right">
      10GB of <strong>250GB</strong> Free.
  </div>
  <div>
      <strong>Copyright</strong> Example Company &copy; 2014-2018
  </div>
</div>